import { render, staticRenderFns } from "./GeneraCodigos.vue?vue&type=template&id=d22d6658&"
import script from "./GeneraCodigos.vue?vue&type=script&lang=js&"
export * from "./GeneraCodigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports